/**
 * Giphy (external service) request constants.
 * Not part of API_ENDPOINTS — those are relative to the WLB API base URL.
 */
export const GIPHY_API_BASE_URL = 'https://api.giphy.com/v1/gifs';

export const GIPHY_ENDPOINTS = {
  TRENDING: '/trending',
  SEARCH: '/search',
} as const;

export const GIPHY_RESULT_LIMIT = 20;

export const GIPHY_SEARCH_DEBOUNCE_MS = 500;

export const GIF_MIME_TYPE = 'image/gif';

/** CDN base prepended to remote GIF paths in Feeds/Post `MediaUrl` only. */
export const GIPHY_CDN_BASE_URL = 'https://media4.giphy.com';
